//@ts-nocheck
import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

import { changePassword, logout } from '../actions/UserActions';

import { useDispatch, useSelector } from 'react-redux';

import { Button, Form, FormGroup, FormControl, Alert, FormLabel } from "react-bootstrap";
import { ReportText, TextSpan } from './Common/SharedStyledComponents';

import { UserState } from '../interface/MyInterfaces';


interface PasswordChangeModalProps {
    showPasswordModal: boolean;
    handleClose: Function;
    username?: any;
}


const PasswordChangeModal = ({ showPasswordModal, handleClose, username }: PasswordChangeModalProps) => {

    const [showModal, setShowModal] = useState(showPasswordModal);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [statusMessage, setStatusMessage] = useState("");

    useEffect(() => {
        setPassword("");
        setConfirmPassword("");
        setShowModal(showPasswordModal);
    }, [showPasswordModal]);

    //const username = useSelector(state => ({ userProperties: state.userProperties.username }))

    //const username = UserState && UserState.username;
    //console.log(UserState);
    const dispatch = useDispatch();

    /**
     * Password validation and submit action
     * */
    const ChangePassword = () => {

        if (password === "" || confirmPassword === "") {
            setStatusMessage("Passwords cannot be empty");
            setPassword("");
            setConfirmPassword("");
            return;
        }

        if (password.length < 8) {
            setStatusMessage("Passwords should be longer than 8 characters");
            setPassword("");
            setConfirmPassword("");
            return;
        }

        if (password === confirmPassword) {

            dispatch(changePassword(username, password))
            setPassword("");
            setConfirmPassword("");
            setStatusMessage("");
            handleClose();
            dispatch(logout());
        } else {
            setStatusMessage("Passwords must match");
            setPassword("");
            setConfirmPassword("");
        }


    }

    /**
     * Function: event handler for updating password state
     * @param e
     */
    const HandlePasswordChange = (e) => {
        if (e.target.value != "") setStatusMessage("");
        setPassword(e.target.value);
    }

    /**
     * Function: event handler for updating confirm password state
     * @param e
     */
    const HandleConfirmPasswordChange = (e) => {
        if (e.target.value != "") setStatusMessage("");
        setConfirmPassword(e.target.value);
    }

    return (
        <ModalContainer
            isOpen={showModal}
            overlayClassName="ChangePasswordFormOverlay"
            ariaHideApp={false}>
            <FormContainer>
                <PasswordForm>
                    <CloseFormButton bsStyle="primary" type="button" onClick={() => handleClose()}>X</CloseFormButton>
                    <ReportText><TextSpan bold>Note: </TextSpan>You will have to log in with your new password after submitting this form.</ReportText>
                    <FormGroup controlId="formPassword">
                        <FormLabel>New Password</FormLabel>
                        <FormControl type="password" placeholder="Password" value={password} onChange={HandlePasswordChange} />
                    </FormGroup>
                    <FormGroup controlId="formConfirmPassword">
                        <FormLabel>Confirm New Password</FormLabel>
                        <FormControl type="password" placeholder="Confirm Password" value={confirmPassword} onChange={HandleConfirmPasswordChange} />
                    </FormGroup>
                    {
                        statusMessage ? <Alert>{statusMessage}</Alert> : <BlankAlert bsStyle="warning" />
                    }
                    <Button onClick={ChangePassword}>Submit</Button>
                </PasswordForm>
            </FormContainer>
        </ModalContainer>
    );
}

/**
 * Styled component: Modifies React Modal to a more minimal design*/
const ModalContainer = styled(ReactModal)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background-color: #ffffff;
    border-radius: 5px;
    font-size: 15px;
`

/**
 * Styled component: blanks out Bootstrap Alert
 * */
export const BlankAlert = styled(Alert)`
    opacity: 0;
`;

/**
 * Styled component: Form container for password inputs
 * */
const FormContainer = styled.div`
    display: grid;
    width: 400px;
    height: 400px;
    padding-inline: 20px;
    padding-block: 20px;
`;

/**
 * Styled component: Modified bootstrap button
 * */
const CloseFormButton = styled(Button)`
    justify-self: flex-end;
    font-size: 10px;
    width: 25px;
    height: 25px;
`;

/**
 * Styled component: modifies bootstrap form
 * */
const PasswordForm = styled(Form)`
    display: grid;
    gap: 1rem;
    width: 100%;
    height: 100%;
`;

export default PasswordChangeModal;